module.exports = __webpack_public_path__ + "static/media/img_0.2ad7145f.png";